<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-3 searching">
                                <span class="h_page">Kegiatan Renja</span> <br> <br>
                            </div>
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button @click="btn_check_data_add()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                                    </span>
                                    <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">
                            <div class="col-md-4">
                                <span class="huruf_input">Unit Kerja</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Periode Renja</span>
                                <select @change="getProgram()" v-model="form.renja" class="form-control show-tick">
                                    <option value="" >-- Semua Periode --</option>
                                    <option v-for="data in list_renja" :key="data.renja_setup_id" :value="data">{{data.renja_jenis}} ({{data.tahun}})</option>
                                </select>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Program Renja</span>
                                <select @change="cari_data()" class="form-control show-tick" v-model="form.renja_program">
                                    <option>-- Semua Program --</option>
                                    <option  v-for="data in list_program" :key="data.renja_program_id" :value="data">[{{data.program_kode}}] {{data.program_nama}}</option>
                                </select>
                            </div>

                            

                        </div>
                        <br>
                        
                        <br>
                        <div class="table-responsive">
                            <table class="table-kiken" style="width: 100%">
                                <thead>
                                <tr class="bg-success kepala_table_f tabel_center">
                                    <th class="tabel_center text-center" style="width: 10%">Kode.</th>
                                    <th class="tabel_center text-center" style="width: 20%">Nama Kegiatan</th>
                                    <th class="tabel_center text-center" style="width: 8%">Prioritas</th>
                                    <th class="tabel_center text-center" style="width: 8%">Status <br> Renja</th>
                                    <th class="tabel_center text-center" style="width: 9%">Jumlah <br> Anggaran RKPD</th>
                                    <th class="tabel_center text-center" style="width: 9%" >Jml Rincian <br> Anggaran</th>
                                    <th class="tabel_center text-center" style="width: 9%">Rincian <br> Anggaran</th>
                                    <th class="tabel_center text-center" style="width: 9%">Indikator <br> Kinerja</th>

                                    <th class="text-center" style="width: 18%">#</th>
                                </tr>
                                </thead>
                                <tbody class="tabel_center" >
                                    <tr class="h_isitable" v-for="data in list_data" :key="data.renja_kegiatan_id">
                                        <td class="tabel_center text-center">
                                            <div v-if="data.cek_program_renja <= 0">
                                                <a @click="selectDataSync(data)" href="javascript:void(0);" title="Tidak Terkoneksi dengan Renja Program" data-toggle="modal" data-target="#m_konektifitas_data_program">
                                                    <i class="material-icons" style="color:#FF8A33">report</i>
                                                </a>
                                            </div>
                                            <div v-if="data.cek_program_renja > 0">
                                                <div v-if="data.cek_kegiatan_rkpd <= 0">
                                                    <a @click="selectDataSync(data)" href="javascript:void(0);" title="Tidak Terkoneksi dengan RKPD Kegiatan" data-toggle="modal" data-target="#m_konektifitas_data_kegiatan">
                                                        <i class="material-icons" style="color:#e04747">report</i>
                                                    </a>
                                                </div>
                                                <div v-if="data.cek_kegiatan_rkpd > 0">
                                                    {{data.kegiatan_kode}}
                                                </div>
                                            </div>
                                            
                                        </td>
                                        <td class="tabel_center" >{{data.kegiatan_nama}}</td>
                                        <td class="tabel_center text-center" >{{data.prioritas_nama}}</td>
                                        <td class="tabel_center text-center" >{{data.renja_status}}</td>
                                        <td class="tabel_center" >{{format_uang(data.anggaran_rkpd)}}</td>
                                        <td class="tabel_center" :style="cek_kelebihan(data.anggaran_rkpd, data.TOTAL)">{{cek_null(data.TOTAL)}}</td>
                                        <td class="tabel_center text-center">
                                            <button @click="selectData(data)" t type="button" title="Tambah Rincian Anggaran" class="btn bg-blue-grey waves-effect btn-xs" data-toggle="modal" data-target="#m_list_data_rincian"> &nbsp; {{format_uang(data.jml_kegiatan)}}  &nbsp;</button>
                                        </td>
                                        <td class="tabel_center text-center" >
                                            <button @click="selectData(data)" type="button" title="Tambah Indikator Kinerja" class="btn bg-blue-grey waves-effect btn-xs" data-toggle="modal" data-target="#m_list_data_indikator"> &nbsp; {{data.jml_indikator}} &nbsp;</button>
                                        </td>
                                        <td class="tabel_center text-center" >
                                            <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Sasaran Kegiatan" data-toggle="modal" data-target="#m_list_sasaran">
                                                <i class="material-icons" >settings</i>
                                            </button>
                                            &nbsp;
                                            <!-- <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" data-toggle="modal" data-target="#m_edit_data">
                                                <i class="material-icons" >create</i>
                                            </button>
                                            &nbsp; -->
                                            <button @click="removeData(data.renja_kegiatan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data">
                                                <i class="material-icons" >clear</i>
                                            </button>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                        <hr>
                            <!-- <div class="text-center">
                                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                                    <i class="material-icons">skip_previous</i>
                                </button>
                                &nbsp;
                                <span style="font-size: 85%; color: #a5a5a5">
                                    <b>{{page_first}} - {{page_last}}</b>
                                </span>
                                &nbsp;
                                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                                    <i class="material-icons">skip_next</i>
                                </button>
                            </div> -->
                        <hr>
                        <!-- ============================================================ MODAL ======================================================================== -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                        </div>

                                        <form @submit.prevent="addData()">

                                            <div class="modal-body">
                                                <div v-if="!check_data_add" class="alert alert-info text-center">
                                                    <strong>SILAHKAN PILIH PROGRAM RENJA TERLEBIH DAHULU!</strong> 
                                                </div>

                                                <div v-if="check_data_add">

                                                    <div class="table-responsive">
                                                        <table class="table table-bordered" style="width: 100%">
                                                            <thead>
                                                            <tr class="bg-success kepala_table_f tabel_center">

                                                                <th class="text-center" style="width: 10%">Kode</th>
                                                                <th class="text-center" style="width: 20%">Kegiatan</th>
                                                                <th class="text-center" style="width: 10%">Target RKPD</th>
                                                                <th class="text-center" style="width: 10%">Prioritas</th>
                                                                <th class="text-center" style="width: 15%">#</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody class="tabel_center" >
                                                            <tr class="h_isitable" v-for="data in list_kegiatan" :key="data.rkpd_kegiatan_id">
                                                                <td class="tabel_center text-center" >{{data.kode}}</td>
                                                                <td class="tabel_center" >{{data.kegiatan_nama}}</td>
                                                                <td class="tabel_center text-center" >{{format_uang(data.rkpd_target)}}</td>
                                                                <td class="tabel_center text-center" >{{data.prioritas}}</td>
                                                                <td class="tabel_center text-center" >
                                                                    <input 
                                                                        v-model="form.rkpd_kegiatan" type="checkbox" :value="{
                                                                            kegiatan_id : data.kegiatan_id, 
                                                                            rkpd_kegiatan_id : data.rkpd_kegiatan_id, 
                                                                            rkpd_program_id: data.rkpd_program_id,
                                                                            bidang_urusan_pemerintahan_id : data.bidang_urusan_pemerintahan_id
                                                                        }" 
                                                                        :id="data.rkpd_kegiatan_id" class="filled-in chk-col-blue" :checked="1">
                                                                    <label :for="data.rkpd_kegiatan_id"></label>
                                                                </td>
                                                            </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST SASARAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_list_sasaran" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-green">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">LIST SASARAN KEGIATAN</h4>
                                        </div>
                                            <div class="modal-body">

                                                <button class="btn bg-light-green"  data-toggle="modal" data-target="#m_add_sasaran">TAMBAH SASARAN</button>

                                                <hr>
                                                <div class="table-responsive">
                                                    <table class="table-kiken" style="width: 100%">
                                                        <thead>
                                                        <tr class="bg-success kepala_table_f tabel_center">
                                                            <th class="tabel_center text-center" style="width: 5%">Kode.</th>
                                                            <th class="tabel_center text-center" style="width: 70%">Nama Kegiatan</th>

                                                            <th class="text-center" style="width: 20%">#</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody class="tabel_center" >
                                                            <tr class="h_isitable" v-for="data in list_sasaran" :key="data.renja_kegiatan_sasaran_id">
                                                                <td class="tabel_center text-center">{{data.no}}</td>
                                                                <td class="tabel_center" >{{data.uraian}}</td>
                                                                <td class="tabel_center text-center" >
                                                                    <button @click="selectSasaran(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" data-toggle="modal" data-target="#m_edit_sasaran">
                                                                        <i class="material-icons" >create</i>
                                                                    </button>
                                                                    &nbsp;
                                                                    <button @click="removeSasaran(data.renja_kegiatan_sasaran_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" >
                                                                        <i class="material-icons" >clear</i>
                                                                    </button>
                                                                </td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>


                                            </div>
                                            <div class="modal-footer">
                                                <!-- <button type="submit" class="btn btn-success waves-effect"></button> -->
                                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>

                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST SASARAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD SASARAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_add_sasaran" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-md" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH SASARAN KEGIATAN</h4>
                                        </div>
                                            <div class="modal-body">
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">No</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="sasaran.no" type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Sasaran</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="sasaran.uraian" type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Keterangan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <textarea class="form-control" v-model="sasaran.keterangan"></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>



                                            </div>
                                            <div class="modal-footer">
                                                <button @click="addSasaran()" type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>

                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD SASARAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT SASARAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edit_sasaran" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-md" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-orange">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT SASARAN KEGIATAN</h4>
                                        </div>
                                            <div class="modal-body">
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">No</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="sasaran.no" type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Sasaran</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="sasaran.uraian" type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Keterangan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <textarea class="form-control" v-model="sasaran.keterangan"></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>



                                            </div>
                                            <div class="modal-footer">
                                                <button @click="editSasaran()" type="submit" class="btn bg-orange waves-effect">EDIT</button>
                                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>

                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT SASARAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST INDIKATOR xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_list_data_indikator" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-xlg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">LIST INDIKATOR</h4>
                                        </div>

                                           
                                        <div class="modal-body">
                                            <button data-toggle="modal" data-target="#m_tambah_data_indikator_kinerja" class="btn btn-info">Tambah Indikator</button>
                                            <hr>
                                            <div class="table-responsive">
                                                <table class="table-bordered" style="width: 100%;">
                                                    <thead>
                                                        <tr class="bg-info kepala_table_f tabel_center">
                                                            <th class="tabel_center text-center" style="width: 10%;">No</th>
                                                            <th class="tabel_center text-center" style="width: 40%;">Uraian Indikator</th>
                                                            <th class="tabel_center text-center" style="width: 10%;">Satuan</th>
                                                            <th class="tabel_center text-center" style="width: 10%;">Realisasi s/d Tahun Lalu</th>
                                                            <th class="tabel_center text-center" style="width: 10%;">Target Tahun Ini</th>
                                                            <th class="tabel_center text-center" style="width: 10%;">Target Tahun Depan</th>
                                                            <th class="tabel_center text-center" style="width: 10%;">#</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr class="h_isitablex" v-for="(data, index) in list_indikator" :key="data.renja_kegiatan_indikator_id">
                                                            <td class="tabel_center text-center">{{index+1}}</td>
                                                            <td class="tabel_center">{{data.uraian}}</td>
                                                            <td class="tabel_center text-center">{{data.satuan}}</td>
                                                            <td class="tabel_center text-center">{{data.realisasi_thn_lalu}}</td>
                                                            <td class="tabel_center text-center">{{data.target_thn_ini}}</td>
                                                            <td class="tabel_center text-center">{{data.target_thn_depan}}</td>
                                                            <td class="tabel_center text-center">
                                                                <button @click="selectDataIndikator(data)" title="Edit Data" data-toggle="modal" data-target="#m_edit_data_indikator_kinerja" class="btn bg-light-green btn-xs waves-effect">
                                                                    <i class="material-icons" style="font-size: 100%;">create</i>
                                                                </button>
                                                                &nbsp;
                                                                <button  @click="removeDataIndikator(data.renja_kegiatan_indikator_id)"  title="Hapus Data" class="btn bg-red btn-xs waves-effect">
                                                                    <i class="material-icons" style="font-size: 100%;">clear</i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>













                                            <div class="modal-footer">
                                                <!-- <button type="submit" class="btn btn-info waves-effect">SIMPAN</button> -->
                                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST INDIKATOR xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH INDIKATOR KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_tambah_data_indikator_kinerja" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">INDIKATOR SASARAN KEGIATAN</h4>
                                        </div>
                                    <form @submit.prevent="addindikator()">
                                        <div class="modal-body">

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">No Indikator</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.no_indikator" type="number" class="form-control" placeholder="Ex : 1">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Uraian Indikator</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.uraian" type="text" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Satuan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.satuan" type="text" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Realisasi s/d Tahun Lalu</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.realisasi_thn_lalu" type="number" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Target Tahun Ini</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.target_thn_ini" type="number" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Target Tahun Depan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.target_thn_depan" type="number" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="modal-footer">
                                            <button type="submit" class="btn bg-light-blue waves-effect" >SIMPAN</button>
                                            <button  type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH INDIKATOR KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT INDIKATOR KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edit_data_indikator_kinerja" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-green">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">UBAH INDIKATOR SASARAN KEGIATAN</h4>
                                        </div>
                                    <form @submit.prevent="editindikator()">
                                        <div class="modal-body">
                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">No Indikator</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.no_indikator" type="number" class="form-control" placeholder="Ex : 1">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Uraian Indikator</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.uraian" type="text" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Satuan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.satuan" type="text" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Realisasi s/d Tahun Lalu</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.realisasi_thn_lalu" type="number" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Target Tahun Ini</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.target_thn_ini" type="number" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Target Tahun Depan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.target_thn_depan" type="number" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="modal-footer">
                                            <button type="submit" class="btn bg-light-green waves-effect" >SIMPAN</button>
                                            <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT INDIKATOR KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST RINCIAN KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_list_data_rincian" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-xlg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">LIST RINCIAN KEGIATAN</h4>
                                        </div>

                                        <div class="modal-body">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <span class="huruf_input">Sifat Kegiatan</span>
                                                    <select class="form-control" v-model="rincian.id_sikd_sifat_kgtn">
                                                        <option v-for="data in list_sifat_kegiatan" :key="data.id_sikd_sifat_kgtnUtama" :value="data.id_sikd_sifat_kgtn">{{data.nama}}</option>
                                                    </select>
                                                </div>
                                                <div class="col-md-6">
                                                    <span class="huruf_input">Prioritas</span>
                                                    <select class="form-control" v-model="rincian.prioritas">
                                                        <option>P1</option>
                                                        <option>P2</option>
                                                        <option>P3</option>
                                                        <option>P4</option>
                                                        <option>P5</option>
                                                        <option>P6</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <span class="huruf_input">Jenis Kegiatan</span>
                                                    <select class="form-control" v-model="rincian.jenis_kgtn">
                                                        <option>Kegiatan Sedang Berjalan</option>
                                                        <option>Kegiatan Alternatif</option>
                                                        <option>Kegiatan Baru</option>
                                                    </select>
                                                </div>
                                                <div class="col-md-6">
                                                    <span class="huruf_input">Sumber Anggaran</span>
                                                    <select class="form-control" v-model="rincian.id_sikd_sumber_anggaran">
                                                        <option v-for="data in list_sumber_anggaran" :key="data.id_sikd_sumber_anggaran" :value="data.id_sikd_sumber_anggaran">{{data.nm_sumber_anggaran}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <hr>

                                            <div class="table-responsive">
                                                <table class="table-kiken" style="width: 100%">
                                                    <thead>
                                                    <tr class="kepala_table_f tabel_center bg-light-green">
                                                        <th class="tabel_center text-center" style="width: 10%">Nomor</th>
                                                        <th class="tabel_center text-center" style="width: 35%">Uraian</th>
                                                        <th class="tabel_center text-center" style="width: 10%">Volume</th>
                                                        <th class="tabel_center text-center" style="width: 10%">Satuan</th>
                                                        <th class="tabel_center text-center" style="width: 10%">Harga</th>
                                                        <th class="tabel_center text-center" style="width: 15%" >Jumlah</th>
                                                        <th class="text-center" style="width: 10%">
                                                            <button @click="cek_add_rincian()" type="button" class="btn bg-green waves-effect"  data-toggle="modal" data-target="#m_tambah_rincian_kegiatan">TAMBAH RINCIAN</button>
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody class="tabel_center" >
                                                        <template  v-for="data in list_rincian">
                                                            <tr class="h_isitable bg-success" :key="data.renja_kegiatan_rincian_id">
                                                                <td class="tabel_center">{{data.kode}}</td>
                                                                <td class="tabel_center" ><i>{{data.uraian}}</i></td>
                                                                <td class="tabel_center text-center" >{{cek_null(data.vol)}}</td>
                                                                <td class="tabel_center text-center" >{{cek_null(data.sat)}}</td>
                                                                <td class="tabel_center">{{cek_null(data.harga)}}</td>
                                                                <td class="tabel_center">{{cek_jumlah_rincian(data)}}</td>
                                                                <td class="tabel_center text-center" >
                                                                    <button @click="selectRincian(data)" class="btn bg-blue btn-xs waves-effect" title="Tambah sub rincian" id="edit_data" data-toggle="modal" data-target="#m_list_data_sub_rincian">
                                                                        <i class="material-icons" >add</i>
                                                                    </button>
                                                                    &nbsp;
                                                                    <button @click="selectRincian(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_rincian_kegiatan">
                                                                        <i class="material-icons" >create</i>
                                                                    </button>
                                                                    &nbsp;
                                                                    <button @click="removeRincian(data.renja_kegiatan_rincian_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                                        <i class="material-icons" >clear</i>
                                                                    </button>
                                                                </td>
                                                            </tr>

                                                            <template v-for="data1 in data.renja_kegiatan_subrincian">
                                                                <tr class="h_isitable bgcol-abuabumuda" :key="data1.renja_kegiatan_subrincian_id+'xxx'">
                                                                    <td class="tabel_center">{{data.kode}}.{{data1.kode}}</td>
                                                                    <td class="tabel_center" >- {{data1.uraian}}</td>
                                                                    <td class="tabel_center text-center" >{{cek_null(data1.vol)}}</td>
                                                                    <td class="tabel_center text-center" >{{cek_null(data1.sat)}}</td>
                                                                    <td class="tabel_center ">{{cek_null(data1.harga)}}</td>
                                                                    <td class="tabel_center ">{{cek_jumlah(data1)}}</td>
                                                                    <td class="tabel_center text-center" >
                                                                        <button @click="selectSubRincian(data1)" class="btn bg-blue btn-xs waves-effect" title="Tambah sub rincian" id="edit_data" data-toggle="modal" data-target="#m_list_data_sub_sub_rincian">
                                                                            <i class="material-icons" >add</i>
                                                                        </button>
                                                                        &nbsp;
                                                                        <button @click="selectSubRincian(data1)"  class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data_sub_rincian">
                                                                            <i class="material-icons" >create</i>
                                                                        </button>
                                                                        &nbsp;
                                                                        <button @click="removeSubRincian(data1.renja_kegiatan_subrincian_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                                            <i class="material-icons" >clear</i>
                                                                        </button>
                                                                    </td>
                                                                </tr>

                                                                <template  v-for="data2 in data1.renja_kegiatan_subsubrincian">
                                                                    <tr class="h_isitable" :key="data2.renja_kegiatan_subsubrincian_id+'yyy'">
                                                                        <td class="tabel_center">{{data.kode}}.{{data1.kode}}.{{data2.kode}}</td>
                                                                        <td class="tabel_center" style="padding-left:1.5%;">- {{data2.uraian}}</td>
                                                                        <td class="tabel_center text-center" >{{data2.vol}}</td>
                                                                        <td class="tabel_center text-center" >{{data2.sat}}</td>
                                                                        <td class="tabel_center ">{{format_uang(data2.harga)}}</td>
                                                                        <td class="tabel_center ">{{format_uang(data2.harga * data2.vol)}}</td>
                                                                        <td class="tabel_center text-center" >
                                                                            <button class="btn bg-blue btn-xs waves-effect" title="Item ini dinonaktifkan" disabled>
                                                                                <i class="material-icons" >add</i>
                                                                            </button>
                                                                            &nbsp;
                                                                            <button @click="selectSubSubRincian(data2)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edt_data_sub_sub_rincian">
                                                                                <i class="material-icons" >create</i>
                                                                            </button>
                                                                            &nbsp;
                                                                            <button  @click="removeSubSubRincian(data2.renja_kegiatan_subsubrincian_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                                                <i class="material-icons" >clear</i>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </template>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>

                                            
                                        </div>
                                        <div class="modal-footer">
                                            <!-- <button type="submit" class="btn btn-info waves-effect">SIMPAN</button> -->
                                            <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST RINCIAN KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD RINCIAN KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_tambah_rincian_kegiatan" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-md" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH RINCIAN KEGIATAN</h4>
                                        </div>
                                        <div class="modal-body">
                                            <div class="text-center" v-if="cek_rincian">
                                                <h5 style="color:red">HARAP LENGKAPI LIST PILIHAN DULU...!!</h5>
                                            </div>

                                            <div v-if="!cek_rincian">

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Kode</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="rincian.kode" type="number" class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Uraian</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="rincian.uraian" type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Volume</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="rincian.vol" type="number" class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Satuan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="rincian.sat" type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Harga</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="rincian.harga" type="number" class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            
                                        </div>
                                        <div class="modal-footer">
                                            <button v-if="!cek_rincian" @click="addRincian()" type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                            <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD RINCIAN KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT RINCIAN KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edit_rincian_kegiatan" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-md" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT RINCIAN KEGIATAN</h4>
                                        </div>
                                        <div class="modal-body">
                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Kode</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="rincian.kode" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Uraian</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="rincian.uraian" type="text" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Volume</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="rincian.vol" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Satuan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="rincian.sat" type="text" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Harga</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="rincian.harga" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div class="modal-footer">
                                            <button @click="updateRincian()" type="submit" class="btn btn-success waves-effect">UBAH</button>
                                            <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT RINCIAN KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD SUB RINCIAN KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_list_data_sub_rincian" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-md" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH SUB RINCIAN KEGIATAN</h4>
                                        </div>

                                        <div class="modal-body">
                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Kode</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subrincian.kode" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Uraian</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subrincian.uraian" type="text" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Volume</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subrincian.vol" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Satuan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subrincian.sat" type="text" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Harga</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subrincian.harga" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            
                                        </div>
                                        <div class="modal-footer">
                                            <button @click="addSubRincian()" type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                            <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD SUB RINCIAN KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT SUB RINCIAN KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edit_data_sub_rincian" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-md" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-green">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT SUB RINCIAN KEGIATAN</h4>
                                        </div>

                                        <div class="modal-body">
                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Kode</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subrincian.kode" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Uraian</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subrincian.uraian" type="text" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Volume</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subrincian.vol" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Satuan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subrincian.sat" type="text" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Harga</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subrincian.harga" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            
                                        </div>
                                        <div class="modal-footer">
                                            <button @click="updateSubRincian()" type="submit" class="btn btn-success waves-effect">UBAH</button>
                                            <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT SUB RINCIAN KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD SUB SUB RINCIAN KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_list_data_sub_sub_rincian" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-md" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH SUB-SUB RINCIAN KEGIATAN</h4>
                                        </div>

                                        <div class="modal-body">
                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Kode</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subsubrincian.kode" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Uraian</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subsubrincian.uraian" type="text" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Volume</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subsubrincian.vol" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Satuan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subsubrincian.sat" type="text" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Harga</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subsubrincian.harga" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            
                                        </div>
                                        <div class="modal-footer">
                                            <button @click="addSubSubRincian()" type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                            <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD SUB SUB RINCIAN KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT SUB SUB RINCIAN KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edt_data_sub_sub_rincian" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-md" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-green">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT SUB-SUB RINCIAN KEGIATAN</h4>
                                        </div>

                                        <div class="modal-body">
                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Kode</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subsubrincian.kode" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Uraian</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subsubrincian.uraian" type="text" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Volume</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subsubrincian.vol" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Satuan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subsubrincian.sat" type="text" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Harga</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="subsubrincian.harga" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            
                                        </div>
                                        <div class="modal-footer">
                                            <button @click="updateSubSubRincian()" type="submit" class="btn btn-success waves-effect">UBAH</button>
                                            <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT SUB SUB RINCIAN KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA SYNC PROGRAM xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal" id="m_konektifitas_data_program" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-orange">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <span style="font-size:120%">ATUR RELASI PROGRAM (RENJA)</span> <br>
                                            <i><span style="font-size:80%">[{{Sync.program_kode}}]. {{Sync.program_nama}}</span></i>
                                            
                                        </div>
                                        <form @submit.prevent="editDataSync()">
                                            <div class="modal-body">

                                                <div class="row clearfix">
                                                    <div class="col-md-3 form-control-label">
                                                        <label for="kode">Program Pembangunan (RKPD)</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <select class="form-control" v-model="Sync.renja_program_id">
                                                                <option v-for="(data, index) in list_program_sync" :key="data.renja_program_id+index" :value="data.renja_program_id">[{{data.program_kode}}]. {{data.program_nama}}</option>
                                                            </select>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-warning waves-effect">SINKRONISASI</button>
                                                <button  @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA SYNC PROGRAM xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA SYNC KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal" id="m_konektifitas_data_kegiatan" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-red">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <span style="font-size:120%">ATUR RELASI KEGIATAN xx(RKPD)</span> <br>
                                            <i><span style="font-size:80%">[{{Sync.kegiatan_kode}}]. {{Sync.kegiatan_nama}}</span></i>
                                            
                                        </div>
                                        <form @submit.prevent="editDataSyncKegiatan()">
                                            <div class="modal-body">

                                                <div class="row clearfix">
                                                    <div class="col-md-3 form-control-label">
                                                        <label for="kode">Program Pembangunan (RKPD)</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <select class="form-control" v-model="Sync.rkpd_kegiatan_id">
                                                                <option v-for="(data, index) in list_kegiatan_sync" :key="data.rkpd_kegiatan_id+index" :value="data.rkpd_kegiatan_id">[{{data.kegiatan_kode}}]. {{data.kegiatan_nama}}</option>
                                                            </select>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-warning waves-effect">SINKRONISASI</button>
                                                <button  @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA SYNC KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- ============================================================ MODAL ======================================================================== -->
                <!-- ============================================================ MULAI ======================================================================== -->
                    </div>

                </div>

            </div>
      </section>



    </div>
</template>

<script>

    const ADD_URL = URL_APP+'api/v1/planning_renja_kegiatan/';




    const ADD_URL_RENJA = URL_APP+'api/v1/planning_renja_setup/';
    const ADD_URL_RENJA_PROGRAM = URL_APP+'api/v1/planning_renja_program/';
    const ADD_URL_RKPD_KEGIATAN = URL_APP+'api/v1/planning_rkpd_kegiatan/';

    const ADD_URL_TAHUN = URL_APP+'api/v1/planning_tahun/';
    const URL_SERVER = URL_APP;
    import Autocomplete from 'vue2-autocomplete-js'


    export default {
        name: "planning_rpjmd",
        components: { Autocomplete },
        data() {
            return {
                form : {
                    id_renstra : '',
                    renja_setup_id : '',
                    renja_kegiatan_id : '',
                    urusan_pemerintahan_id : '',
                    bidang_urusan_pemerintahan_id: '',
                    program_id : '',
                    renja_program_id : '',
                    rkpd_program_id : '',
                    rkpd_kegiatan_id : '',
                    kegiatan_id : '',
                    
                    tahun : '',
                    instansi_id : '',
                    unit_kerja : '',

                    rkpd_kegiatan : [],
                    renja_program: {},
                    renja : {},
                },

                indikator : {
                    renja_kegiatan_indikator_id : '',
                    renja_kegiatan_id : '',
                    kegiatan_id : '',

                    no_indikator : 0,
                    uraian : '',
                    satuan : '',

                    realisasi_thn_lalu : 0,
                    target_thn_ini : 0,
                    target_thn_depan : 0,
                },

                sasaran : {
                    renja_kegiatan_sasaran_id : '',
                    renja_kegiatan_id : '',
                    no : '',
                    uraian : '',
                    keterangan : ''
                },

                rincian :{
                    renja_kegiatan_rincian_id : '',
                    prioritas : '',
                    id_sikd_sifat_kgtn : '',
                    jenis_kgtn : '',
                    id_sikd_sumber_anggaran : '',
                    sifat : '',
                    kode : '',
                    uraian : '',
                    vol : 0,
                    sat : '',
                    harga : 0,
                },
                subrincian :{
                    renja_kegiatan_subrincian_id : '',
                    renja_kegiatan_id : '',
                    renja_kegiatan_rincian_id : '',
                    kode : '',
                    uraian : '',
                    vol : 0,
                    sat : '',
                    harga : 0,
                },
                subsubrincian :{
                    renja_kegiatan_subsubrincian_id : '',
                    renja_kegiatan_subrincian_id : '',
                    renja_kegiatan_rincian_id : '',
                    renja_kegiatan_id : '',
                    kode : '',
                    uraian : '',
                    vol : 0,
                    sat : '',
                    harga : 0,
                },
                Sync : {
                    renja_kegiatan_id : '',
                    renja_setup_id : '',
                    rkpd_program_id : '',
                    rkpd_kegiatan_id : '',
                    renja_program_id : '',
                    kegiatan_kode : '',
                    kegiatan_nama : '',
                    program_kode : '',
                    program_nama : ''
                },


                unit_kerja : '',
                unit_kerja_full : '',





                check_data_add : false,
                list_data : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',

                list_tahun : [],
                list_renja : [],
                list_program : [],
                list_program_sync : [],
                list_kegiatan_sync : [],
                list_kegiatan : [],
                list_sasaran : [],
                list_indikator : [],

                list_rincian : [],
                list_sub_rincian : [],
                list_sub_sub_rincian : [],

                list_sifat_kegiatan : [],
                list_sumber_anggaran : [],

                cek_rincian : false,

                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;

            this.form.unit_kerja = get_profile.profile.unit_kerja;
            this.form.instansi_id = get_profile.profile.instansi_id;
            this.instansi_id = get_profile.profile.instansi_id;


            this.getRenja();
            localStorage.sidemenu = 'planing';
        },

    // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify(this.form)


                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
                // console.log(this.form);
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value,
                      instansi_id : this.form.instansi_id,
                      renja_setup_id : this.form.renja.renja_setup_id,
                      renja_program_id : this.form.renja_program.renja_program_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data.data;
                  this.page_last = res_data.jml_data;
                  console.log(res_data);
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.form)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
                    console.log(data);

                    this.form.id_renstra = data.id_renstra;
                    this.form.renja_setup_id = data.renja_setup_id;
                    this.form.renja_kegiatan_id = data.renja_kegiatan_id;
                    this.form.bidang_urusan_pemerintahan_id = data.bidang_urusan_pemerintahan_id;
                    this.form.program_id = data.program_id;
                    this.form.renja_program_id  = data.renja_program_id;
                    this.form.rkpd_program_id = data.rkpd_program_id;
                    this.form.rkpd_kegiatan_id = data.rkpd_kegiatan_id;
                    this.form.kegiatan_id = data.kegiatan_id;
                    
                    this.form.tahun = data.tahun;
                    this.form.instansi_id = data.instansi_id;
                    this.form.unit_kerja = data.unit_kerja;


                this.indikator.renja_kegiatan_id = data.renja_kegiatan_id;
                this.indikator.kegiatan_id = data.kegiatan_id;

                this.sasaran.renja_kegiatan_id = data.renja_kegiatan_id;


                this.getSasaran()
                this.getDataTahun();
                this.getDataIndikator();
                this.getSumberAnggaran();
                this.getSifatKegiatan();
                this.getRincian();
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.list_kegiatan = [];
                this.form.rkpd_kegiatan = [];
                this.list_indikator = [];



                this.list_rincian = [];
                this.list_sub_rincian = [];
                this.list_sub_sub_rincian = [];

                this.cek_rincian = false;

                this.getData();
                
            },

        //TAMBAHAN
            selectDataSync : function(data){
                console.log(data)

                this.Sync = {
                    renja_kegiatan_id : data.renja_kegiatan_id,
                    renja_setup_id : data.renja_setup_id,
                    rkpd_program_id : data.rkpd_program_id_fix,
                    rkpd_kegiatan_id : data.rkpd_kegiatan_id,
                    renja_program_id : data.renja_program_id,
                    kegiatan_kode : data.kegiatan_kode,
                    kegiatan_nama : data.kegiatan_nama,
                    program_kode : data.program_kode,
                    program_nama : data.program_nama,
                },
                this.getProgramSync();
                this.getKegiatanSync();
            },
            editDataSync : function(){
                fetch(ADD_URL+'updateDataSync', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        renja_kegiatan_id : this.Sync.renja_kegiatan_id,
                        renja_program_id : this.Sync.renja_program_id,
                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            editDataSyncKegiatan : function(){
                fetch(ADD_URL+'updateDataSyncKegiatan', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        renja_kegiatan_id : this.Sync.renja_kegiatan_id,
                        rkpd_kegiatan_id : this.Sync.rkpd_kegiatan_id,
                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            getProgramSync: function(){
                fetch(ADD_URL_RENJA_PROGRAM+'fromRenja', {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.unit_kerja,
                        renja_setup_id : this.form.renja.renja_setup_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_program_sync = res_data;
                    // console.log(res_data)
                })
            },

            getKegiatanSync: function(){
                fetch(ADD_URL_RKPD_KEGIATAN+'fromRenja', {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        instansi_id : this.instansi_id,
                        rkpd_program_id : this.Sync.rkpd_program_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_kegiatan_sync = res_data;
                    console.log(res_data);
                })
            },

            getRenja : function(){
                fetch(ADD_URL_RENJA+'by_renja', {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.unit_kerja,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_renja = res_data;
                    this.form.renja = res_data[0];
                    this.getProgram()
                })
            },
            getProgram : function(){
                fetch(ADD_URL_RENJA_PROGRAM+'fromRenja', {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.unit_kerja,
                        renja_setup_id : this.form.renja.renja_setup_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                    if (res_data.length <= 0) {
                        this.form.renja_program = {}
                        // this.form.renja_program.renja_program_id = '';
                    }else{
                        this.list_program = res_data;
                        this.form.renja_program = res_data[0]
                        this.getData();
                        this.getKegiatan();
                    }
                })
            },

            getKegiatan : function(){
                fetch(ADD_URL_RKPD_KEGIATAN+'fromRenja', {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        instansi_id : this.instansi_id,
                        rkpd_program_id : this.form.renja_program.rkpd_program_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_data.forEach(list_data => {
                        for (let i = 0; i < res_data.length; i++) {
                            if (list_data.rkpd_kegiatan_id == res_data[i].rkpd_kegiatan_id) {
                                res_data.splice(i, 1); 
                            }
                        }
                    });
                    this.list_kegiatan = res_data;
                    // console.log(res_data);
                })
            },
            getDataIndikator: function(){
                fetch(ADD_URL+'readDataDataIndikator1', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({

                      renja_kegiatan_id : this.form.renja_kegiatan_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_indikator = res_data;
                  console.log(res_data);
                })
            },
            addindikator : function(){
                fetch(ADD_URL+'createDataIndikator', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.indikator)
                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getDataIndikator();
                });
            },
            editindikator : function(){
                fetch(ADD_URL+'updateDataIndikator', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify(this.indikator)


                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Mengubah Data!');
                    this.getDataIndikator();
                });
            },
            removeDataIndikator : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteDataIndikator", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getDataIndikator();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            selectDataIndikator : function(data){
                this.indikator = {
                    renja_kegiatan_indikator_id : data.renja_kegiatan_indikator_id,
                    renja_kegiatan_id : data.renja_kegiatan_id,
                    kegiatan_id : data.kegiatan_id,

                    no_indikator : data.no_indikator,
                    uraian : data.uraian,
                    satuan : data.satuan,

                    realisasi_thn_lalu : data.realisasi_thn_lalu,
                    target_thn_ini : data.target_thn_ini,
                    target_thn_depan : data.target_thn_depan,
                };
            },

            getSumberAnggaran : function(){
                fetch(ADD_URL+'readDataSIKD_sumber_anggaran', {
                    method : 'GET',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    }
                }).then((res) => res.json()).then((res_data) => {
                    this.list_sumber_anggaran = res_data;
                    // console.log(res_data);
                })
            },
            getSifatKegiatan : function(){
                fetch(ADD_URL+'readDataSIKDSifatKegiatan', {
                    method : 'GET',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    }
                }).then((res) => res.json()).then((res_data) => {
                    this.list_sifat_kegiatan = res_data;
                    // console.log('====================================');
                    // console.log(res_data);
                })
            },

        // ======================== SASARAN =========================    
            addSasaran : function(){
                fetch(ADD_URL+'addSasaranKegiatan', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.sasaran)
                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getSasaran();
                });
            },
            editSasaran : function(){
                fetch(ADD_URL+'updateSasaranKegiatan', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.sasaran)
                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getSasaran();
                });
            },
            selectSasaran : function(data){
                this.sasaran = {
                    renja_kegiatan_sasaran_id : data.renja_kegiatan_sasaran_id,
                    renja_kegiatan_id : data.renja_kegiatan_id,
                    no : data.no,
                    uraian : data.uraian,
                    keterangan : data.keterangan,
                };
            },
            getSasaran : function(){
                fetch(ADD_URL+'getSasaranKegiatan', {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        renja_kegiatan_id : this.sasaran.renja_kegiatan_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_sasaran = res_data;
                    // console.log(res_data);
                })
            },
            removeSasaran : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"removeSasaran", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getSasaran();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
        // ======================== SASARAN =========================    
            
        // ======================== RINCIAN =========================    
            addRincian : function(){
                fetch(ADD_URL+'createDataRincian', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        renja_kegiatan_id : this.form.renja_kegiatan_id,
                        prioritas : this.rincian.prioritas,
                        id_sikd_sifat_kgtn : this.rincian.id_sikd_sifat_kgtn,
                        jenis_kgtn : this.rincian.jenis_kgtn,
                        id_sikd_sumber_anggaran : this.rincian.id_sikd_sumber_anggaran,
                        sifat : this.rincian.sifat,
                        kode : this.rincian.kode,
                        uraian : this.rincian.uraian,
                        vol : this.rincian.vol,
                        sat : this.rincian.sat,
                        harga : this.rincian.harga,
                    })
                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getRincian();
                });
            },
            getRincian : function(){
                fetch(ADD_URL+'getDataRincian', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        renja_kegiatan_id : this.form.renja_kegiatan_id,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_rincian = res_data;
                    console.log('====================================');
                    console.log(res_data);
                })
            },
            removeRincian : function(id){
                fetch(ADD_URL+'removeDataRincian', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        id : id,
                    })
                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menghapus Data!');
                    this.getRincian();
                });
            },
            updateRincian : function(id){
                fetch(ADD_URL+'updateDataRincian', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        renja_kegiatan_rincian_id : this.rincian.renja_kegiatan_rincian_id,
                        kode : this.rincian.kode,
                        uraian : this.rincian.uraian,
                        vol : this.rincian.vol,
                        sat : this.rincian.sat,
                        harga : this.rincian.harga,
                    })
                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menghapus Data!');
                    this.getRincian();
                });
            },
            selectRincian : function(data){
                this.subrincian.renja_kegiatan_rincian_id = data.renja_kegiatan_rincian_id;
                this.subrincian.renja_kegiatan_id = data.renja_kegiatan_id;
                this.rincian.renja_kegiatan_rincian_id = data.renja_kegiatan_rincian_id;
                this.rincian.kode = data.kode;
                this.rincian.uraian = data.uraian;
                this.rincian.vol = data.vol;
                this.rincian.sat = data.sat;
                this.rincian.harga = data.harga;

            },
        // ======================== RINCIAN =========================

        // ======================== SUB RINCIAN =========================
            addSubRincian : function(){
                fetch(ADD_URL+'createDataSubRincian', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.subrincian)
                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getRincian();
                });
            },
            selectSubRincian : function(data){
                // console.log(data);

                this.subsubrincian.renja_kegiatan_subrincian_id = data.renja_kegiatan_subrincian_id;
                this.subsubrincian.renja_kegiatan_rincian_id = data.renja_kegiatan_rincian_id;
                this.subsubrincian.renja_kegiatan_id = data.renja_kegiatan_id;

                this.subrincian = {
                    renja_kegiatan_subrincian_id : data.renja_kegiatan_subrincian_id,
                    renja_kegiatan_id : data.renja_kegiatan_id,
                    renja_kegiatan_rincian_id : data.renja_kegiatan_rincian_id,
                    kode : data.kode,
                    uraian : data.uraian,
                    vol : data.vol,
                    sat : data.sat,
                    harga : data.harga,
                };
            },
            updateSubRincian : function(){
                fetch(ADD_URL+'updateDataSubRincian', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.subrincian)
                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Merubah Data!');
                    this.getRincian();
                });
            },
            removeSubRincian : function(id){
                fetch(ADD_URL+'removeDataSubRincian', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        id : id,
                    })
                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menghapus Data!');
                    this.getRincian();
                });
            },

        // ======================== SUB RINCIAN =========================


        // ======================== SUB SUB RINCIAN =========================
            addSubSubRincian : function(){
                fetch(ADD_URL+'createDataSubSubRincian', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.subsubrincian)
                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getRincian();
                });
            },
            updateSubSubRincian : function(){
                fetch(ADD_URL+'updateDataSubSubRincian', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.subsubrincian)
                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Merubah Data!');
                    this.getRincian();
                });
            },
            removeSubSubRincian : function(id){
                fetch(ADD_URL+'removeDataSubSubRincian', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        id : id,
                    })
                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menghapus Data!');
                    this.getRincian();
                });
            },
            selectSubSubRincian: function(data){
                this.subsubrincian = {
                    renja_kegiatan_subsubrincian_id : data.renja_kegiatan_subsubrincian_id,
                    renja_kegiatan_subrincian_id : data.renja_kegiatan_subrincian_id,
                    renja_kegiatan_rincian_id : data.renja_kegiatan_rincian_id,
                    renja_kegiatan_id : data.renja_kegiatan_id,
                    kode : data.kode,
                    uraian : data.uraian,
                    vol : data.vol,
                    sat : data.sat,
                    harga : data.harga,
                };
            },

        // ======================== SUB SUB RINCIAN =========================

        // ======================== CEK NILAI RINCIAN =========================

            cek_jumlah : function(data){
                var jumlah = 0;
                var data_length = data.renja_kegiatan_subsubrincian

                if (data_length == undefined) {
                    return this.format_uang(data.vol * data.harga)
                }else{
                    for (let i = 0; i < data_length.length; i++) {
                        var n = data_length[i].vol * data_length[i].harga
                        jumlah = jumlah + n;
                        
                    }
                    return this.format_uang(jumlah)
                }

            },
            cek_jumlah_rincian : function(data){
                var jml_subrincian = 0;
                var jml_subsubrincian = 0;

                var subrincian = data.renja_kegiatan_subrincian;
                // console.log(subrincian);

                if (subrincian === undefined) {
                    // console.log('tidak ada');
                    return this.format_uang(data.vol * data.harga)
                }else{
                    console.log(subrincian.length);
                    
                    for (let i = 0; i < subrincian.length; i++) {

                        var subsubrincian1 = subrincian[i].renja_kegiatan_subsubrincian;
                        var n = subrincian[i].vol * subrincian[i].harga;

                        jml_subrincian = jml_subrincian + n;

                        // console.log(subsubrincian1.length);

                        if (subsubrincian1 != undefined) {
                            for (let j = 0; j < subsubrincian1.length; j++) {
                                var m = subsubrincian1[j].vol * subsubrincian1[j].harga
                                console.log(m);
                                jml_subsubrincian = jml_subsubrincian + m;
                            }
                        }

                    }
                    // // console.log(jml_subsubrincian);
                    return this.format_uang(jml_subrincian + jml_subsubrincian)


                }

            },
            cek_null : function(variable){
                if(variable == 0 || variable == '-'|| variable == '0'|| variable == ' '|| variable == null){
                    return ''
                }else{
                    if(typeof variable == 'number'){
                         return this.format_uang(variable)
                    }else{
                        return variable
                    }
                }

            },


        // ======================== CEK NILAI RINCIAN =========================





        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            cek_add_rincian : function(){

                if (
                    this.rincian.prioritas == '' ||
                    this.rincian.id_sikd_sifat_kgtn == '' ||
                    this.rincian.jenis_kgtn == '' ||
                    this.rincian.id_sikd_sumber_anggaran == ''

                ) {
                    this.cek_rincian = true;
                }else{
                    this.cek_rincian = false;
                }

            },
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.form.unit_kerja = obj.id;
                this.getRenja();

                this.instansi_id = obj.instansi_id
                this.form.instansi_id = obj.instansi_id;
                // console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            btn_check_data_add : function(){
                // console.log(this.form.renja_program);
                // this.getDataTahun();
                if (this.isEmpty(this.form.renja_program)) {
                }else{
                    this.check_data_add = true;
                    this.getKegiatan();
                }
            },
            isEmpty: function(obj) {
                for(var key in obj) {
                    if(obj.hasOwnProperty(key))
                        return false;
                }
                return true;
            },
            getDataTahun: function(){
                fetch(ADD_URL_TAHUN, {
                    method : 'GET',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                }).then((res) => res.json()).then((res_data) => {
                    this.list_tahun = res_data;
                    // console.log(res_data);
                })
            },
            getTgl : function(){
                var d = new Date();
                return {
                    tahun : d.getFullYear(),
                }
            },
            format_uang : function(nilai, prefix){
                var angka = parseFloat(nilai)
                if (angka == null || angka == '' || angka == undefined) {
                    return angka;
                } else {
                    var rupiah = '';		
                    var angkarev = angka.toString().split('').reverse().join('');
                    for(var i = 0; i < angkarev.length; i++) if(i%3 == 0) rupiah += angkarev.substr(i,3)+'.';
                    return ''+rupiah.split('',rupiah.length-1).reverse().join('');
                }
            },
            cek_kelebihan(data1, data2){
                    if(typeof data2 == 'number'){
                         if (data1 > data2) {
                            return 'background : #adebad'
                        }else if (data1 == data2){
                            return ''
                        }else{
                            return 'background : #ffd9cc'
                        }
                    }

                
            },

        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>